import { Injectable} from '@angular/core';
import { FormBuilderUDFService } from './services/form-builder-udf-service';
import { Renderer2 } from '@angular/core';
import { Grid, GridOptions } from 'ag-grid-community';
import { DropdownOperationService } from './dropdown-operation.service';
import { SharedOperationService } from './shared-operation.service';


@Injectable({
  providedIn: 'root'
})
export class ListOperationService {
  jsonData :any;
  dataFromShared :any;
  agGridInstances: any[] = [];
  renderer: Renderer2;
  frameworkComponents: any;

  constructor(private sharedService: SharedOperationService, private formService: FormBuilderUDFService) {
    this.agGridInstances = [];
    this.sharedService.formViewerData$.subscribe((data) => {
      if (data) {
        this.dataFromShared = data;
      }
    });
    // this.frameworkComponents = {
    //   editButtonRenderer: ButtonEditRendererComponent
    // };
  }


  async createListGrid(element: any, container: any) {
    container = container === undefined ? this.dataFromShared?.nativeElement : container;
    const agGridElement = container?.querySelector(`#${element.field_name}`);

    if (agGridElement) {
      const elementConfig = element;

      if (elementConfig) {
        let rowData = elementConfig.rowData;
        if (elementConfig.datasourceUrl) {
          setTimeout(async () => {
            await this.fetchDataFromApi(elementConfig, container);
          }, 0);
        } else {
          const gridOptions: GridOptions = {
            animateRows: true,
            pagination: true,
            columnDefs: elementConfig.columnDefs,
            rowData: rowData,
            onGridReady: (params) => {
              this.agGridInstances.push({ gridName: element.field_name, api: params.api });
              params.api.sizeColumnsToFit();
            }
          };
          new Grid(agGridElement, gridOptions);
        }
      }
    }
  }

  
  async fetchDataFromApi(element: any, container: any): Promise<void> {
    const params = this.sharedService.constructDependentParams(element.field_name, container, this.getDropdownConfig.bind(this));
    return new Promise<void>((resolve, reject) => {
      this.sharedService.fetchDataFromAPI(params, element.datasourceUrl, element.requestType, element.apiDirectoryId, element.isExternalAPI).then(data => {
        const gridData = element.resultsetName !== '' ? data[element.resultsetName] : data;
        const rowData = gridData;
  
        const gridElement = container?.querySelector(`#${element.field_name}`);
        //========================= Adding button as per configuration ========//
       
        const actionsColumn = {
          headerName: 'Actions',
          cellRenderer: (params: any) => {
            const eDiv = document.createElement('div');
  
            if (element?.buttonEdit) {
              const editButton = document.createElement('button');
              editButton.innerHTML = '<i style="color:white" class="fa fa-edit"></i>';
              editButton.style.backgroundColor = 'blue';
              editButton.style.color = 'white';
              editButton.style.border = 'none';
              editButton.style.padding = '5px 10px';
              editButton.style.borderRadius = '4px';
              editButton.style.cursor = 'pointer';
              editButton.style.marginRight = '5px';
              editButton.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                this.onEdit(params, container);
              });
              eDiv.appendChild(editButton);
            }
  
            if (element?.buttonDelete) {
              const deleteButton = document.createElement('button');
              deleteButton.innerHTML = '<i style="color:white" class="fa fa-trash"></i>';
              deleteButton.style.backgroundColor = 'red';
              deleteButton.style.color = 'white';
              deleteButton.style.border = 'none';
              deleteButton.style.padding = '5px 10px';
              deleteButton.style.borderRadius = '4px';
              deleteButton.style.cursor = 'pointer';
              deleteButton.style.marginRight = '5px';
              deleteButton.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                this.onDelete(params);
              });
              eDiv.appendChild(deleteButton);
            }
  
            if (element?.buttonView) {
              const viewButton = document.createElement('button');
              viewButton.innerHTML = '<i style="color:white" class="fa fa-eye"></i>';
              viewButton.style.backgroundColor = 'green';
              viewButton.style.color = 'white';
              viewButton.style.border = 'none';
              viewButton.style.padding = '5px 10px';
              viewButton.style.borderRadius = '4px';
              viewButton.style.cursor = 'pointer';
              viewButton.style.marginRight = '5px';
              viewButton.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                this.onView(params);
              });
              eDiv.appendChild(viewButton);
            }
  
            return eDiv;
          },
          width: 150
        };
  
        if (!element.columnDefs.some((col: any) => col.headerName === 'Actions')) {
          element.columnDefs.push(actionsColumn);
        }
  
        console.log('Column Definitions:', element.columnDefs);
  
        if (rowData.length > 0) {
          if (gridElement) {
            const existingGridInstance = gridElement.firstChild && gridElement.__agGridInstance;
  
            if (existingGridInstance) {
              existingGridInstance.api.setRowData(rowData.map((data: any, index: number) => this.transformData(data, index, element.columnDefs)));
            } else {
              const gridOptions: GridOptions = {
                animateRows: true,
                pagination: true,
                columnDefs: element.columnDefs,
                rowData: rowData.map((data: any, index: number) => this.transformData(data, index, element.columnDefs)),
                context: {
                  componentParent: this
                },
                onGridReady: (params) => {
                  gridElement.__agGridInstance = params;
                  this.agGridInstances.push({ gridName: element.field_name, data: params });
                  params.api.sizeColumnsToFit();
                }
              };
  
              console.log('Grid Options:', gridOptions);
              new Grid(gridElement, gridOptions);
            }
          }
          resolve();
        } else {
          if (gridElement) {
            const existingGridInstance = gridElement.__agGridInstance;
  
            if (existingGridInstance) {
              existingGridInstance.api.setRowData(null);
              existingGridInstance.api.setColumnDefs(element.columnDefs);
            } else if (gridElement.__ag_grid_instance === undefined) {
              const gridOptions: GridOptions = {
                animateRows: true,
                pagination: true,
                columnDefs: element.columnDefs,
                rowData: [],
                context: {
                  componentParent: this
                },
                onGridReady: (params) => {
                  gridElement.__agGridInstance = params;
                  this.agGridInstances.push({ gridName: element.field_name, api: params.api });
                  params.api.sizeColumnsToFit();
                }
              };
  
              new Grid(gridElement, gridOptions);
            }
          }
          console.log(`Data not found in the response for ${element.field_name}`);
          reject();
        }
      }).catch(error => {
        console.log(`Error fetching data for ${element.field_name}:`, error);
        reject();
      });
    });
  }

  
//========================here Transforming data for binding data in grid======================//
  transformData = (data: any, index: number, columnDefs: any): any => {

    if (typeof data?.form_data === 'string') {
      try {
        data = JSON.parse(data?.form_data);
      } catch (e) {
        console.error('Failed to parse JSON:', e);
        return null; 
      }
    }
    let transformedData: any = {};

    for (let i = 0; i < columnDefs.length; i++) {
      let key = columnDefs[i]?.field;
      if (data?.hasOwnProperty(key) && key !== undefined) {
        if (typeof data[key] === 'object' && data[key] !== null && 'text' in data[key]) {
          transformedData[key] = data[key].text;
          transformedData[key + 'Id'] = data[key].value;
        } else {
          transformedData[key] = data[key];
        }
      }
    }

    return transformedData;
  };

  capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  //============================Getting grid data=======================//
  getGridData() {
    console.log('Fetching grid data');
    const rowData: any[] = [];
    this.agGridInstances.forEach(gridInstance => {
      const gridData: any[] = [];
      console.log('Grid Instance:', gridInstance);
      gridInstance.api.forEachNode((node: any) => {
        gridData.push(node.data);
      });
      rowData.push({ gridName: gridInstance.gridName, data: gridData });
    });
    console.log('All Grid Data:', rowData);
    return rowData;
  }


  async onEdit(data: any, container: any) {
    console.log(this.dataFromShared);
    localStorage.setItem('rowId',data?.data?.id); // setting id for update the record
    const formContainer = container?.querySelector('form');
    if (!formContainer) return;
  
    const inputs = formContainer.querySelectorAll('input, select, textarea');
    for (const input of inputs) {
      const key = input.name;
      if (key && data.data[key] !== undefined) {
        switch (input.type) {
          case 'radio':
          case 'checkbox':
            input.checked = !!data.data[key];
            break;
          case 'date':
            input.value = new Date(data.data[key]).toISOString().split('T')[0]; // format date correctly
            break;
          case 'text':
          case 'textarea':
            input.value = data.data[key];
            break;
          default:
            input.value = data.data[key + 'Id'];
            break;
        }
  
        if (input.tagName === 'SELECT') {
          const dropdownOperationService = new DropdownOperationService(this.formService, this.sharedService);
          await dropdownOperationService.onDropdownChange(input.name, container, this.renderer);
        }
      }
    }
  }
  

  onView(params: any) {
    throw new Error('Method not implemented.');
  }
  onDelete(data:any) {
    const key = {
      id: data.data.id,
      pageId: 0,
      group : 0,
      plant: 0,
      formBuilderMainId: 0,
      formdata: 0,
      TransactionType: 3
    };
    this.formService.saveFormData(key).subscribe(async (response: { Table: { Column1: string | undefined; }[]; }) => {
      this.refreshGrid();
     
    }, (error: any) => {
      console.error('Error saving form data:', error);
    });
  };

  refreshGrid() {
    for (const component of this.dataFromShared?.json_data?.added_components) {
      if (component.addedComponents) {
        for (const innerComponents of component.addedComponents) {
          for (const innerComponent of innerComponents) {
           if (innerComponent.elementName === 'list' && innerComponent.element.datasourceUrl) {
              this.createListGrid(innerComponent.element, this.dataFromShared?.container?.nativeElement);
            }
          }
        }
      }
    }
  }

  getDropdownConfig(dropdownName: string): any {
    let config = null;
   this.jsonData = this.jsonData === undefined ? this.dataFromShared?.json_data : this.jsonData; 
    this.jsonData?.added_components?.forEach((component: any) => {
      if (component.addedComponents) {
        component.addedComponents.forEach((innerComponents: any[]) => {
          innerComponents.forEach((innerComponent: any) => {
            if (innerComponent.elementName === 'dropdown' && innerComponent.element.field_name === dropdownName) {
              config = innerComponent;
            }
            else if (innerComponent.elementName === 'list' && innerComponent.element.field_name === dropdownName) {
              config = innerComponent;
            }
          });
        });
      }
    });
    return config;
  }
}
